import { render, staticRenderFns } from "./modal-remove-member-workspace.vue?vue&type=template&id=4e2e68cd&"
import script from "./modal-remove-member-workspace.vue?vue&type=script&lang=js&"
export * from "./modal-remove-member-workspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports